module.exports = __webpack_public_path__ + "static/media/bg_02.4fc96cd1.jpg";